// extracted by mini-css-extract-plugin
export var deleteIcon = "_u8-5";
export var deleteOption = "_u8-3";
export var divider = "_u8-2";
export var downloadIcon = "_u8-4";
export var drawer = "_u8-0";
export var drawerFooter = "_u8-6";
export var drawerOpen = "_u8-1";
export var highlighted = "_u8-7";
export var lighterHighlight = "_u8-8";